// source: types/dashboard_layout.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.types.DashboardItem', null, global);
goog.exportSymbol('proto.types.DashboardItem.Kind', null, global);
goog.exportSymbol('proto.types.DashboardItem.Width', null, global);
goog.exportSymbol('proto.types.DashboardItemPosition', null, global);
goog.exportSymbol('proto.types.DashboardItemPosition.PositionCase', null, global);
goog.exportSymbol('proto.types.DashboardItemPosition.Web', null, global);
goog.exportSymbol('proto.types.DashboardLayout', null, global);
goog.exportSymbol('proto.types.DashboardLayout.Mobile', null, global);
goog.exportSymbol('proto.types.DashboardLayout.Row', null, global);
goog.exportSymbol('proto.types.DashboardLayout.Web', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.DashboardLayout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.DashboardLayout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.DashboardLayout.displayName = 'proto.types.DashboardLayout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.DashboardLayout.Mobile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.types.DashboardLayout.Mobile.repeatedFields_, null);
};
goog.inherits(proto.types.DashboardLayout.Mobile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.DashboardLayout.Mobile.displayName = 'proto.types.DashboardLayout.Mobile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.DashboardLayout.Web = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.types.DashboardLayout.Web.repeatedFields_, null);
};
goog.inherits(proto.types.DashboardLayout.Web, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.DashboardLayout.Web.displayName = 'proto.types.DashboardLayout.Web';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.DashboardLayout.Row = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.types.DashboardLayout.Row.repeatedFields_, null);
};
goog.inherits(proto.types.DashboardLayout.Row, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.DashboardLayout.Row.displayName = 'proto.types.DashboardLayout.Row';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.DashboardItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.DashboardItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.DashboardItem.displayName = 'proto.types.DashboardItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.DashboardItemPosition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.types.DashboardItemPosition.oneofGroups_);
};
goog.inherits(proto.types.DashboardItemPosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.DashboardItemPosition.displayName = 'proto.types.DashboardItemPosition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.DashboardItemPosition.Web = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.DashboardItemPosition.Web, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.DashboardItemPosition.Web.displayName = 'proto.types.DashboardItemPosition.Web';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.DashboardLayout.prototype.toObject = function(opt_includeInstance) {
  return proto.types.DashboardLayout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.DashboardLayout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardLayout.toObject = function(includeInstance, msg) {
  var f, obj = {
    mobile: (f = msg.getMobile()) && proto.types.DashboardLayout.Mobile.toObject(includeInstance, f),
    web: (f = msg.getWeb()) && proto.types.DashboardLayout.Web.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.DashboardLayout}
 */
proto.types.DashboardLayout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.DashboardLayout;
  return proto.types.DashboardLayout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.DashboardLayout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.DashboardLayout}
 */
proto.types.DashboardLayout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.types.DashboardLayout.Mobile;
      reader.readMessage(value,proto.types.DashboardLayout.Mobile.deserializeBinaryFromReader);
      msg.setMobile(value);
      break;
    case 2:
      var value = new proto.types.DashboardLayout.Web;
      reader.readMessage(value,proto.types.DashboardLayout.Web.deserializeBinaryFromReader);
      msg.setWeb(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.DashboardLayout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.DashboardLayout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.DashboardLayout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardLayout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMobile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.types.DashboardLayout.Mobile.serializeBinaryToWriter
    );
  }
  f = message.getWeb();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.types.DashboardLayout.Web.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.types.DashboardLayout.Mobile.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.DashboardLayout.Mobile.prototype.toObject = function(opt_includeInstance) {
  return proto.types.DashboardLayout.Mobile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.DashboardLayout.Mobile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardLayout.Mobile.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.types.DashboardItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.DashboardLayout.Mobile}
 */
proto.types.DashboardLayout.Mobile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.DashboardLayout.Mobile;
  return proto.types.DashboardLayout.Mobile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.DashboardLayout.Mobile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.DashboardLayout.Mobile}
 */
proto.types.DashboardLayout.Mobile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.types.DashboardItem;
      reader.readMessage(value,proto.types.DashboardItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.DashboardLayout.Mobile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.DashboardLayout.Mobile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.DashboardLayout.Mobile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardLayout.Mobile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.types.DashboardItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DashboardItem items = 1;
 * @return {!Array<!proto.types.DashboardItem>}
 */
proto.types.DashboardLayout.Mobile.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.types.DashboardItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.types.DashboardItem, 1));
};


/**
 * @param {!Array<!proto.types.DashboardItem>} value
 * @return {!proto.types.DashboardLayout.Mobile} returns this
*/
proto.types.DashboardLayout.Mobile.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.types.DashboardItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.types.DashboardItem}
 */
proto.types.DashboardLayout.Mobile.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.DashboardItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.DashboardLayout.Mobile} returns this
 */
proto.types.DashboardLayout.Mobile.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.types.DashboardLayout.Web.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.DashboardLayout.Web.prototype.toObject = function(opt_includeInstance) {
  return proto.types.DashboardLayout.Web.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.DashboardLayout.Web} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardLayout.Web.toObject = function(includeInstance, msg) {
  var f, obj = {
    rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.types.DashboardLayout.Row.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.DashboardLayout.Web}
 */
proto.types.DashboardLayout.Web.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.DashboardLayout.Web;
  return proto.types.DashboardLayout.Web.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.DashboardLayout.Web} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.DashboardLayout.Web}
 */
proto.types.DashboardLayout.Web.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.types.DashboardLayout.Row;
      reader.readMessage(value,proto.types.DashboardLayout.Row.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.DashboardLayout.Web.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.DashboardLayout.Web.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.DashboardLayout.Web} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardLayout.Web.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.types.DashboardLayout.Row.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Row rows = 1;
 * @return {!Array<!proto.types.DashboardLayout.Row>}
 */
proto.types.DashboardLayout.Web.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.types.DashboardLayout.Row>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.types.DashboardLayout.Row, 1));
};


/**
 * @param {!Array<!proto.types.DashboardLayout.Row>} value
 * @return {!proto.types.DashboardLayout.Web} returns this
*/
proto.types.DashboardLayout.Web.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.types.DashboardLayout.Row=} opt_value
 * @param {number=} opt_index
 * @return {!proto.types.DashboardLayout.Row}
 */
proto.types.DashboardLayout.Web.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.DashboardLayout.Row, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.DashboardLayout.Web} returns this
 */
proto.types.DashboardLayout.Web.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.types.DashboardLayout.Row.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.DashboardLayout.Row.prototype.toObject = function(opt_includeInstance) {
  return proto.types.DashboardLayout.Row.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.DashboardLayout.Row} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardLayout.Row.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.types.DashboardItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.DashboardLayout.Row}
 */
proto.types.DashboardLayout.Row.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.DashboardLayout.Row;
  return proto.types.DashboardLayout.Row.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.DashboardLayout.Row} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.DashboardLayout.Row}
 */
proto.types.DashboardLayout.Row.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.types.DashboardItem;
      reader.readMessage(value,proto.types.DashboardItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.DashboardLayout.Row.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.DashboardLayout.Row.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.DashboardLayout.Row} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardLayout.Row.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.types.DashboardItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DashboardItem items = 1;
 * @return {!Array<!proto.types.DashboardItem>}
 */
proto.types.DashboardLayout.Row.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.types.DashboardItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.types.DashboardItem, 1));
};


/**
 * @param {!Array<!proto.types.DashboardItem>} value
 * @return {!proto.types.DashboardLayout.Row} returns this
*/
proto.types.DashboardLayout.Row.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.types.DashboardItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.types.DashboardItem}
 */
proto.types.DashboardLayout.Row.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.DashboardItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.types.DashboardLayout.Row} returns this
 */
proto.types.DashboardLayout.Row.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional Mobile mobile = 1;
 * @return {?proto.types.DashboardLayout.Mobile}
 */
proto.types.DashboardLayout.prototype.getMobile = function() {
  return /** @type{?proto.types.DashboardLayout.Mobile} */ (
    jspb.Message.getWrapperField(this, proto.types.DashboardLayout.Mobile, 1));
};


/**
 * @param {?proto.types.DashboardLayout.Mobile|undefined} value
 * @return {!proto.types.DashboardLayout} returns this
*/
proto.types.DashboardLayout.prototype.setMobile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.types.DashboardLayout} returns this
 */
proto.types.DashboardLayout.prototype.clearMobile = function() {
  return this.setMobile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.DashboardLayout.prototype.hasMobile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Web web = 2;
 * @return {?proto.types.DashboardLayout.Web}
 */
proto.types.DashboardLayout.prototype.getWeb = function() {
  return /** @type{?proto.types.DashboardLayout.Web} */ (
    jspb.Message.getWrapperField(this, proto.types.DashboardLayout.Web, 2));
};


/**
 * @param {?proto.types.DashboardLayout.Web|undefined} value
 * @return {!proto.types.DashboardLayout} returns this
*/
proto.types.DashboardLayout.prototype.setWeb = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.types.DashboardLayout} returns this
 */
proto.types.DashboardLayout.prototype.clearWeb = function() {
  return this.setWeb(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.DashboardLayout.prototype.hasWeb = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.DashboardItem.prototype.toObject = function(opt_includeInstance) {
  return proto.types.DashboardItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.DashboardItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    width: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.DashboardItem}
 */
proto.types.DashboardItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.DashboardItem;
  return proto.types.DashboardItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.DashboardItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.DashboardItem}
 */
proto.types.DashboardItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.types.DashboardItem.Kind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {!proto.types.DashboardItem.Width} */ (reader.readEnum());
      msg.setWidth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.DashboardItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.DashboardItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.DashboardItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.types.DashboardItem.Kind = {
  DEVICE_STATUS_OVERVIEW: 0,
  TIP_CAROUSEL: 1,
  CONSUMPTION_GRAPH: 2,
  CURRENT_MONTH_CONSUMPTION: 3,
  SPACE_COMPARISON: 4,
  CURRENT_MONTH_COSTS: 5,
  CONSUMPTION_TARGET: 6,
  TARIFF_SWITCH_STATUS: 7,
  HEADER_MEASUREMENT: 8,
  HEADER_TIPS: 9,
  CREATE_FIRST_SPACE_REMINDER: 10,
  WELCOME_MESSAGE: 11,
  CONNECT_DEVICE_REMINDER: 12,
  UPDATE_MANUAL_READINGS: 13,
  PROMINENT_TIP: 15,
  MARKET_PREMIUM: 16,
  MARKET_PREMIUM_HEADER: 17,
  SPACE_KPIS: 18,
  AUTOMATION_OVERVIEW: 19,
  CREATE_FIRST_AUTOMATION_REMINDER: 20,
  CUSTOMER_IDENTIFIER: 21,
  SMART_HOUSE: 22
};

/**
 * @enum {number}
 */
proto.types.DashboardItem.Width = {
  HALF_WIDTH: 0,
  FULL_WIDTH: 1
};

/**
 * optional Kind kind = 1;
 * @return {!proto.types.DashboardItem.Kind}
 */
proto.types.DashboardItem.prototype.getKind = function() {
  return /** @type {!proto.types.DashboardItem.Kind} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.types.DashboardItem.Kind} value
 * @return {!proto.types.DashboardItem} returns this
 */
proto.types.DashboardItem.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Width width = 2;
 * @return {!proto.types.DashboardItem.Width}
 */
proto.types.DashboardItem.prototype.getWidth = function() {
  return /** @type {!proto.types.DashboardItem.Width} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.types.DashboardItem.Width} value
 * @return {!proto.types.DashboardItem} returns this
 */
proto.types.DashboardItem.prototype.setWidth = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.types.DashboardItemPosition.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.types.DashboardItemPosition.PositionCase = {
  POSITION_NOT_SET: 0,
  MOBILE: 1,
  WEB: 2
};

/**
 * @return {proto.types.DashboardItemPosition.PositionCase}
 */
proto.types.DashboardItemPosition.prototype.getPositionCase = function() {
  return /** @type {proto.types.DashboardItemPosition.PositionCase} */(jspb.Message.computeOneofCase(this, proto.types.DashboardItemPosition.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.DashboardItemPosition.prototype.toObject = function(opt_includeInstance) {
  return proto.types.DashboardItemPosition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.DashboardItemPosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardItemPosition.toObject = function(includeInstance, msg) {
  var f, obj = {
    mobile: jspb.Message.getFieldWithDefault(msg, 1, 0),
    web: (f = msg.getWeb()) && proto.types.DashboardItemPosition.Web.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.DashboardItemPosition}
 */
proto.types.DashboardItemPosition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.DashboardItemPosition;
  return proto.types.DashboardItemPosition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.DashboardItemPosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.DashboardItemPosition}
 */
proto.types.DashboardItemPosition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMobile(value);
      break;
    case 2:
      var value = new proto.types.DashboardItemPosition.Web;
      reader.readMessage(value,proto.types.DashboardItemPosition.Web.deserializeBinaryFromReader);
      msg.setWeb(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.DashboardItemPosition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.DashboardItemPosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.DashboardItemPosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardItemPosition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getWeb();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.types.DashboardItemPosition.Web.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.DashboardItemPosition.Web.prototype.toObject = function(opt_includeInstance) {
  return proto.types.DashboardItemPosition.Web.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.DashboardItemPosition.Web} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardItemPosition.Web.toObject = function(includeInstance, msg) {
  var f, obj = {
    column: jspb.Message.getFieldWithDefault(msg, 1, 0),
    row: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.DashboardItemPosition.Web}
 */
proto.types.DashboardItemPosition.Web.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.DashboardItemPosition.Web;
  return proto.types.DashboardItemPosition.Web.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.DashboardItemPosition.Web} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.DashboardItemPosition.Web}
 */
proto.types.DashboardItemPosition.Web.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setColumn(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.DashboardItemPosition.Web.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.DashboardItemPosition.Web.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.DashboardItemPosition.Web} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.DashboardItemPosition.Web.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColumn();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRow();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 column = 1;
 * @return {number}
 */
proto.types.DashboardItemPosition.Web.prototype.getColumn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.types.DashboardItemPosition.Web} returns this
 */
proto.types.DashboardItemPosition.Web.prototype.setColumn = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 row = 2;
 * @return {number}
 */
proto.types.DashboardItemPosition.Web.prototype.getRow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.types.DashboardItemPosition.Web} returns this
 */
proto.types.DashboardItemPosition.Web.prototype.setRow = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 mobile = 1;
 * @return {number}
 */
proto.types.DashboardItemPosition.prototype.getMobile = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.types.DashboardItemPosition} returns this
 */
proto.types.DashboardItemPosition.prototype.setMobile = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.types.DashboardItemPosition.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.types.DashboardItemPosition} returns this
 */
proto.types.DashboardItemPosition.prototype.clearMobile = function() {
  return jspb.Message.setOneofField(this, 1, proto.types.DashboardItemPosition.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.DashboardItemPosition.prototype.hasMobile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Web web = 2;
 * @return {?proto.types.DashboardItemPosition.Web}
 */
proto.types.DashboardItemPosition.prototype.getWeb = function() {
  return /** @type{?proto.types.DashboardItemPosition.Web} */ (
    jspb.Message.getWrapperField(this, proto.types.DashboardItemPosition.Web, 2));
};


/**
 * @param {?proto.types.DashboardItemPosition.Web|undefined} value
 * @return {!proto.types.DashboardItemPosition} returns this
*/
proto.types.DashboardItemPosition.prototype.setWeb = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.types.DashboardItemPosition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.types.DashboardItemPosition} returns this
 */
proto.types.DashboardItemPosition.prototype.clearWeb = function() {
  return this.setWeb(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.types.DashboardItemPosition.prototype.hasWeb = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.types);
